import React, { useState,useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { tealiumTrack } from './utils/tealium';

import classnames from 'classnames';
import { Button, ButtonGroup } from 'reactstrap';

import MethodologiesHTML from "./components/MethodologiesHTML"

export default function AppAnon(props) {
    const [activeTab, setActiveTab] = useState('1');
    const [sliderValue, setSliderValue] = useState(0);
    const [rSelected, setRSelected] = useState('C');

    let stackData = sliderValue === 0  ? [
        { width: '30%', text: '20-40%' },
        { width: '40%', text: '20-40%' },
        { width: '60%', text: '30-50%' }
    ] : [
        { width: '20%', text: '0-20%' },
        { width: '40%', text: '20-40%' },
        { width: '70%', text: '50-70%' }
    ];

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab); 
		
		
        if (tab == 1) {
            tealiumTrack('bond-pyramid:tab-selected:know','view')
        } else {
            tealiumTrack('bond-pyramid:tab-selected:choose','view')
        }

			
    }



    return (
        <div className="app app-anon">
            <div className="container-fluid"> 
                <section className="row header-section">
                    <div className="container"> 
                        <div className="row">                        
                            <div className="col-12">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            1. Know what role bonds play
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            2. Choose your blend
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="row body-section">
                    <div className="container">
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <div className="container">
                                <div className="row">                        
                                    <div className="col-md-5 landing-blurb">
                                        <h1>
                                            The BlackRock Bond Pyramid
                                        </h1>
                                        <p>                                            
                                            When managing bonds, you need to know what role each fund plays, and then you should consider optimizing your bond mix based on your larger asset allocation. Private credit and liquid alternatives may now be key parts of a strategic bond portfolio.
                                        </p>
                                       	<div className="link-button" onClick={props.setLoggedIn}>
                                            <i className="icon fa fa-angle-right" aria-hidden="true"></i>Get started
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="stack-landing">
                                            <div className="pink">
                                                <section>
                                                    
                                                    <div className="rounded-box">
                                                        Income
                                                        <span className="max-w">Plus bond sectors /<br/>private credit</span>
                                                    </div>
                                                </section>
                                                <p>
                                                    Higher quality income
                                                </p>
                                            </div>
                                            <div className="yellow">
                                                <section>
                                                    <div className="rounded-box"> 
                                                        Stability
                                                        <span className="max-w2">Low duration / flexible strategies</span>
                                                    </div>
                                                </section>
                                                <p>
                                                    Low volatility across fluctuating markets
                                                </p>                                                
                                            </div>
                                            <div className="orange">
                                                <section>
                                                    <div className="rounded-box w-450 text-white">
                                                        Equity diversification                                                    
                                                        <span className="max-w3">Core bonds / <br/>alternative strategies</span>
                                                    </div>
                                                </section>
                                                <p>
                                                    Downside risk mitigation
                                                </p>                                                                                     
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>

                                <MethodologiesHTML/>
                             
                                </div>
                            </TabPane>
                            <TabPane tabId="2">        
                            <div className="container">                    
                                <div className="row">                        
                                    <div className="col-md-5 landing-blurb">
                                        <h1>
                                            The Bond Paradox
                                        </h1>
                                        <p>
                                            Use the BlackRock Bond Pyramid to build a bond allocation that is based on your overall portfolio.
                                        </p>
	                                    <div className="link-button" onClick={props.setLoggedIn}>
                                            <i className="icon fa fa-angle-right" aria-hidden="true"></i>Get started
                                        </div>                                
                                        <MethodologiesHTML/>

                                    </div>
                                    <div className="col-md-7">
                                        <div className="bulb-tip">
                                            <i className="icon fa fa-lightbulb-o"></i>
                                       
                                                <p>As your overall portfolio gets riskier, you may want a more conservative bond allocation.</p>    
                                          
                                        </div>
                                        <div className="slider-container">
                                            <label className="text-small text-faded">Your overall asset allocation is:</label>

                                            <div className="b-container">
                                            	<ButtonGroup size="lg" className="horizontal-button">
													<Button  id="btn1" className="custom-btn" active={rSelected === 'C'} value="C" onClick={() => { setSliderValue(0); setRSelected('C'); tealiumTrack('bond-pyramid:button-selected:conservative','link')  } } >Conservative</Button>
													<Button  className="custom-btn"  active={rSelected === 'A'} value="A" onClick={() => { setSliderValue(1); setRSelected('A'); tealiumTrack('bond-pyramid:button-selected:aggressive','link')}} >Aggressive</Button>
												</ButtonGroup>
                                            </div>
                                        </div>
                                        <label className="text-small text-faded">Consider these bond allocations:</label>
                                        <div className="stack-selection">
                                            <div className="pink">
                                                <section style={{ lineHeight: '12px' }}>
                                                    <div className="rounded-box-step-two h-96" style={{ minHeight: '60px', width: stackData[0].width }}>
                                                          
                                                              <div className="fbold">Income</div>      
                                                              <div>{stackData[0].text}</div>
                                                        
                                                    </div>
                                                </section>
                                            </div>
                                            <div className="yellow">
                                                <section style={{ lineHeight: '12px' }}>
                                                    <div className="rounded-box-step-two h-96" style={{ minHeight: '60px', width: stackData[1].width }}>           
                                                        <div className="fbold">Stability</div>
                                                        <div>{stackData[1].text}</div>
                                                    </div>
                                                </section>                                            
                                            </div>
                                            <div className="orange">
                                                <section className="h-226" style={{ lineHeight: '12px' }}>
                                                    <div className="rounded-box-step-two h-112" style={{ minHeight: '60px', width: stackData[2].width }}>    
                                                        <div className="fbold">Equity diversification</div>
                                                        <div>{stackData[2].text}</div>
                                                    </div>``
                                                </section>                                                                                    
                                            </div>
                                        </div>
                                    </div>
                                </div>

                             

                            </div>
                            </TabPane>
                        </TabContent>
                    </div>
                </section>








            </div>
        </div>
    );
}
